// src/store/slices/shopSlice.ts
import { createSlice, PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";
import { Shop } from "@/types/shop";
import { getShopList } from "@/api/shops";

type ShopState = {
  shops: Shop[];
  loaded: boolean;
  loading: boolean;
};

const initialState: ShopState = {
  shops: [],
  loaded: false,
  loading: false,
};

export const fetchShops = createAsyncThunk(
  "shop/fetchShops",
  async (_, thunkAPI) => {
    const result = await getShopList();
    return result.shops;
  }
);

const shopSlice = createSlice({
  name: "shop",
  initialState,
  reducers: {
    setShops(state, action: PayloadAction<Shop[]>) {
      const shops = action.payload.sort((a, b) => a.shopName.localeCompare(b.shopName));
      state.shops = shops;
      state.loaded = true;
    },
    clearShops(state) {
      state.shops = [];
      state.loaded = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchShops.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchShops.fulfilled, (state, action) => {
        state.loading = false;
        const shops = action.payload.sort((a, b) => a.shopName.localeCompare(b.shopName));
        state.shops = shops;
        state.loaded = true;
      })
      .addCase(fetchShops.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setShops, clearShops } = shopSlice.actions;
export default shopSlice.reducer;